import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import cancel from "../../../assets/cancel.png";
import api from "../../../utils/api";
import Loader from "../../Loader/Loader";
import "./Advertisment__Form.css";

const Advertisment_Form = (props) => {
  const [details, setDetails] = useState({
    name: "",
    from_dt: "",
    to_dt: "",
    description: "",
    banner: "",
  });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(0);
  const [errors, setErrors] = useState({
    name: "",
    description: "",
    from_dt: "",
    to_dt: "",
  });
  const [pdf, setPdf] = useState(null);

  const isEdit = props.isEdit;
  const data = props.data;

  useEffect(() => {
    if (isEdit) {
      setDetails({
        ...details,
        name: data.name,
        from_dt: data.from_dt,
        to_dt: data.to_dt,
        description: data.description,
        banner: JSON.parse(data.banner),
      });
    }
    // eslint-disable-next-line
  }, [isEdit]);

  const handleClick2 = () => {
    props.setDisp();
    props.setEdit();
  };

  const validate = (field, value, allDetails = details) => {
    let error = "";
    if (field === "name" && !value.trim()) {
      error = "Advertisement Title is required";
    }
    if (field === "description" && !value.trim()) {
      error = "Description is required";
    }
    if (field === "from_dt" && !value) {
      error = "From Date is required";
    }
    if (field === "to_dt") {
      if (!value) {
        error = "To Date is required";
      } else if (
        allDetails.from_dt &&
        new Date(value) <= new Date(allDetails.from_dt)
      ) {
        error = "To Date must be greater than From Date";
      }
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedDetails = { ...details, [name]: value };
    setDetails(updatedDetails);

    setErrors((prev) => ({
      ...prev,
      [name]: validate(name, value, updatedDetails),
      ...(name === "from_dt"
        ? {
          to_dt: validate("to_dt", updatedDetails.to_dt, updatedDetails),
        }
        : {}),
    }));
  };

  // Helper: upload a file to the backend and return { url, name }
  const uploadFile = async (file, type) => {
    const form = new FormData();
    form.append("file", file);
    const endpoint = type === "banner" ? "/advertisements/upload/banner" : "/advertisements/upload/pdf";
    const res = await api.post(endpoint, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return { url: res.data.url, name: res.data.name };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting details:", details);

    const newErrors = {
      name: validate("name", details.name),
      description: validate("description", details.description),
      from_dt: validate("from_dt", details.from_dt),
      to_dt: validate("to_dt", details.to_dt, details),
    };

    setErrors(newErrors);

    if (
      newErrors.name ||
      newErrors.description ||
      newErrors.from_dt ||
      newErrors.to_dt
    ) {
      toast.error("Please fix the errors before submitting.");
      return;
    }

    setLoading(1);
    try {
      if (!isEdit) {
        // Local upload — banner + pdf
        const banner = await uploadFile(image, "banner");
        const pdf_url = await uploadFile(pdf, "pdf");

        await api.post(`/advertisements`, {
          name: details.name,
          from: details.from_dt,
          to: details.to_dt,
          banner: banner,
          description: details.description,
          pdf: pdf_url,
        });
        toast.success("Advertisement added successfully!");
      } else {
        // Only re-upload if a new file was selected
        const banner = image ? await uploadFile(image, "banner") : details.banner;
        const pdfData = pdf ? await uploadFile(pdf, "pdf") : details.pdf;

        await api.put(`/advertisements/${data.id}`, {
          name: details.name,
          from: details.from_dt,
          to: details.to_dt,
          description: details.description,
          banner: banner,
          pdf: pdfData,
        });
        toast.success("Advertisement updated successfully!");
      }
      setLoading(0);
      props.setDisp();
      props.fetchData();
      if (props.setEdit) props.setEdit();
    } catch (err) {
      setLoading(0);
      alert("Error saving advertisement.");
      toast.error("Error saving advertisement.");
    }
  };

  const handleUpload = (e) => {
    if (isImage(e.target.files[0].name)) {
      setImage(e.target.files[0]);
    } else {
      e.target.value = "";
      alert("Please select image file.");
    }
  };

  const handlePdfUpload = (e) => {
    if (isPdf(e.target.files[0].name)) {
      setPdf(e.target.files[0]);
    } else {
      e.target.value = "";
      alert("Please select pdf file.");
    }
  };

  function getExtension(filename) {
    var parts = filename.split(".");
    return parts[parts.length - 1];
  }

  function isImage(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "jpeg":
      case "jpg":
      case "png":
        return true;
      default:
        return false;
    }
  }

  function isPdf(filename) {
    var ext = getExtension(filename);
    return ext.toLowerCase() === "pdf";
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="advertisment__form_div_open">
        <div className="advertisment__form" style={{ width: '25%' }}>
          <div className="advertisment__form_header" style={{ width: '100%', padding: '0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <h1 style={{ padding: '0', fontSize: '24px' }}>{isEdit ? "Edits" : "Add"} Advertisement</h1>
              <div className="advertisment__form_img" onClick={handleClick2}>
                <img src={cancel} alt="cancel" />
              </div>
            </div>
          </div>
          <div className="form__grid" style={{ width: '100%' }}>
            <div className="advertisment__form_input big">
              <h5>Advertisement Title</h5>
              <input
                type="text"
                name="name"
                onChange={handleChange}
                value={details.name}
                placeholder="Enter advertisement title"
                className="advertisment__form_input_small"
                style={{ width: '100%', padding: '11px 5px' }}
              />
              {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
            </div>
            <div className="advertisment__form_input">
              <h5>From Date</h5>
              <input
                type="date"
                className="date"
                name="from_dt"
                onChange={handleChange}
                min={new Date().toISOString().split("T")[0]}
                value={
                  details.from_dt
                    ? new Date(details.from_dt).toLocaleDateString("en-CA")
                    : ""
                }
                placeholder="Select start date"
                style={{ width: '100%' }}
              />
              {errors.from_dt && <p style={{ color: "red" }}>{errors.from_dt}</p>}
            </div>
            <div className="advertisment__form_input">
              <h5>To Date</h5>
              <input
                type="date"
                className="date"
                name="to_dt"
                min={new Date().toISOString().split("T")[0]}
                onChange={handleChange}
                value={
                  details.to_dt
                    ? new Date(details.to_dt).toLocaleDateString("en-CA")
                    : ""
                }
                placeholder="Select end date"
                style={{ width: '100%' }}
              />
              {errors.to_dt && <p style={{ color: "red" }}>{errors.to_dt}</p>}
            </div>
            <div className="advertisment__form_input big">
              <h5>Advertiser Description</h5>
              <input
                type="text"
                name="description"
                onChange={handleChange}
                value={details.description}
                placeholder="Enter description"
                className="advertisment__form_input_small"
                style={{ width: '100%', padding: '11px 5px' }}
              />
              {errors.description && (
                <p style={{ color: "red" }}>{errors.description}</p>
              )}
            </div>
            <div className="advertisment__form_input">
              <h5>Banner</h5>
              <input
                type="file"
                accept="image/png, image/jpeg"
                name="banner"
                id="img"
                required={!isEdit}
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  width: '100%'
                }}
                onChange={handleUpload}
              />
              <div className="filename">
                <label>
                  {isEdit && !image?.name && JSON.parse(data.banner).name}
                  {image?.name}
                </label>
              </div>
              <div className="banner__preview">
                {image ? (
                  <img
                    src={URL.createObjectURL(image)}
                    alt="Banner Preview"
                    style={{ maxWidth: "100%", maxHeight: "100px" }}
                  />
                ) : isEdit && details.banner?.url ? (
                  <img
                    src={details.banner.url}
                    alt="Banner Preview"
                    style={{ maxWidth: "100%", maxHeight: "100px" }}
                  />
                ) : (
                  <p>No image selected</p>
                )}
              </div>
            </div>
            <div className="advertisment__form_input">
              <h5>Pdf File</h5>
              <input
                type="file"
                accept="application/pdf"
                name="pdf"
                id="img"
                required={!isEdit}
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  width: '100%'
                }}
                onChange={handlePdfUpload}
              />
              <div className="filename">
                <label>
                  {isEdit && !pdf?.name && JSON.parse(data.pdf).name}
                  {pdf?.name}
                </label>
              </div>
            </div>
          </div>
          <div style={{ width: '100%', padding: '20px' }}>
            {loading ? (
              <Loader small={true} />
            ) : (
              <button className="advertisment__form_button" type="submit" style={{ margin: '0' }}>
                <span style={{ color: "#fff" }}>
                  {isEdit ? "Update" : "Add"} Advertisement
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default Advertisment_Form;